export const API_URL = import.meta.env.VITE_API_URL
export const API_KEY = import.meta.env.VITE_API_KEY
export const CUSTOMERS_KEY = import.meta.env.VITE_API_CUSTOMERS_KEY
export const API_KEY_CLEAN = import.meta.env.VITE_API_URL_CLEAN